import { render, staticRenderFns } from "./GCCAcknowledge.vue?vue&type=template&id=f84fa7dc&"
import script from "./GCCAcknowledge.vue?vue&type=script&lang=js&"
export * from "./GCCAcknowledge.vue?vue&type=script&lang=js&"
import style0 from "./GCCAcknowledge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports